













































import { setCommon } from "@/utils/request";
import {
  localGet,
  setMetaData
} from "@/utils/index";
import {
  ticketClient
} from "@/api/index";
import { WAGetMsgByMobileReq, WASendTextMsgReq, WAMsgReadReq, WAGetChatByMobileReq, WAGetParamByUIDReq } from "@/pbjs/xcommon/ticket_pb.js";
import { Vue, Component, Provide } from "vue-property-decorator";
const WhatsappDialogue = () => import("./components/whatsAppDialogue.vue");
const WhatsappMessage = () => import("./components/whatsAppMessage.vue");
const WhatsappAccountSelect = () => import("./components/whatsAppAccountSelect.vue");
enum READ_STATUS {
  HIDE = 0,
  READ = 1,
  NOT_READ = 2
}
@Component({
  name: "WhatsappChat",
  components: {
    WhatsappDialogue,
    WhatsappMessage,
    WhatsappAccountSelect
  }
})
export default class WhatsappChat extends Vue {
  private created() {
    this.getMessageTemplate().then(templateList => {
      this.messageTemplateArr = templateList
    })
    this.getDialogueList().then(dialoguesArr => {
      this.dialoguesArr = dialoguesArr
      this.setCurrentDialogueIndex()
    })
  }
  @Provide() public dialoguesArr: any[] = [];
  @Provide() public messagesArr: any[] = [];
  @Provide() public currentDialogueIndex: any = null;
  @Provide() public message = '';
  @Provide() public isSendingMessage = false
  @Provide() public userSearchStr = ''
  @Provide() public messageTemplateArr: any[] = [];
  @Provide() public userId = Number(localGet("userid"))
  get currentDialogue() {
    return (this.currentDialogueIndex !== null && this.shownDialoguesArr[this.currentDialogueIndex]) ? this.shownDialoguesArr[this.currentDialogueIndex] : null
  }
  get shownDialoguesArr() {
    let shownDialoguesArr = this.dialoguesArr
    this.currentDialogueIndex = 0
    return shownDialoguesArr.filter((item) => {
      return item.showname.includes(this.userSearchStr) || item.recvmobile.includes(this.userSearchStr)
    })
  }
  get dialogueName() {
    const showname = this.currentDialogue?.showname || ''
    const sendmobile = this.currentDialogue?.sendmobile || ''
    let recvmobile = this.currentDialogue?.recvmobile || ''
    let resultStr = ''
    if (sendmobile) {
      resultStr += `${sendmobile} --> `
    }
    if (showname) {
      resultStr += showname
    } else if (recvmobile) {
      const recvmobileStrArr = recvmobile.split('')
      recvmobileStrArr.splice(-8, 4, '*', '*', '*', '*')
      recvmobile = recvmobileStrArr.join('')
      resultStr += `(${recvmobile})`
    }
    return resultStr
  }
  public setCurrentDialogueIndex(currentDialogueIndex?: number) {
    currentDialogueIndex = currentDialogueIndex ? currentDialogueIndex : 0
    if (!this.shownDialoguesArr[currentDialogueIndex]) {
      return
    }
    this.currentDialogueIndex = currentDialogueIndex
    this.getMessagesList().then(messagesArr => {
      this.messagesArr = messagesArr
      this.setMessageRead()
      this.moveToEnd()
    })
  }
  public templateSearch(queryString: any, cb: any) {
    const result = this.messageTemplateArr.filter(item => {
      return item.title.includes(queryString)
    })
    cb(result)
  }
  public templateSelect(template: any) {
    this.message = template.content
  }
  public clearMessage() {
    this.message = ''
  }
  // public getAllDialogue(currentAccountId: string) {
  //   if (!currentAccountId) {
  //     return
  //   }
  //   this.accountMobile = currentAccountId
  //   this.getDialogueList().then(dialoguesArr => {
  //     this.dialoguesArr = dialoguesArr
  //     this.setCurrentDialogueIndex()
  //   })
  // }
  private getMessageTemplate() {
    let request: any = new WAGetParamByUIDReq();
    request.setCommonin(setCommon());
    request.setUserid(this.userId)
    return new Promise<any[]>(resolve => {
      ticketClient.wAGetParamByUID(
        request,
        setMetaData(),
        (err: any, response: any) => {
          this.handleError(err)
          if (response) {
            const data: any = response.toObject();
            if (data.commonout.code == 0) {
              resolve(data.templateList)
            } else {
              this.$message.error(data.commonout.errmsg);
            }
          }
        }
      );
    })
  }
  private getDialogueList() {
    let request: any = new WAGetChatByMobileReq();
    request.setCommonin(setCommon());
    return new Promise<any[]>(resolve => {
      ticketClient.wAGetChatByMobile(
        request,
        setMetaData(),
        (err: any, response: any) => {
          this.handleError(err)
          if (response) {
            const data: any = response.toObject();
            if (data.commonout.code == 0) {
              resolve(data.chatList)
            } else {
              this.$message.error(data.commonout.errmsg);
            }
          }
        }
      );
    })
  }
  private getMessagesList() {
    return new Promise<any[]>(resolve => {
      if (!this.currentDialogue?.sendmobile || !this.currentDialogue?.recvmobile) {
        return
      }
      let request: any = new WAGetMsgByMobileReq();
      request.setCommonin(setCommon());
      request.setMobile(this.currentDialogue?.sendmobile)
      request.setRecvmobile(this.currentDialogue?.recvmobile)
      // request.setOffset(1)
      ticketClient.wAGetMsgByMobile(
        request,
        setMetaData(),
        (err: any, response: any) => {
          this.handleError(err)
          if (response) {
            const data: any = response.toObject();
            if (data.commonout.code == 0) {
              resolve(data.msgList)
            } else {
              this.$message.error(data.commonout.errmsg);
            }
          }
        }
      );
    })
  }
  public sendMessage() {
    if (!this.currentDialogue?.sendmobile || !this.currentDialogue?.recvmobile) {
      this.$message.error(this.$tc('dashbordDy.pleaseSelectChat'));
      return
    }
    if (!this.message) {
      this.$message.error(this.$tc('dashbordDy.emptyMessage'));
      return
    }
    const hitTemplate = this.messageTemplateArr.filter(template => {
      return this.message === template.content
    })
    if (!hitTemplate.length) {
      this.$message.error(this.$tc('dashbordDy.不支持自定义消息'));
      return
    }
    this.isSendingMessage = true
    let request: any = new WASendTextMsgReq();
    request.setCommonin(setCommon());
    request.setSource(1)
    // 发送者电话不带区号
    request.setWamobile(this.currentDialogue?.sendmobile)
    // 接受者的电话,带区号
    request.setMobile(this.currentDialogue?.recvmobile)
    request.setWatextmsg(this.message)
    if (this.currentDialogue.showname) {
      const orderItemName = this.currentDialogue.showname
      const splitIndex = orderItemName.lastIndexOf('-')
      const orderId = orderItemName.slice(splitIndex + 1)
      if (orderId) {
        request.setOrderid(orderId);
      }
    }
    ticketClient.wASendTextMsg(
      request,
      setMetaData(),
      (err: any, response: any) => {
        this.isSendingMessage = false
        this.handleError(err)
        if (response) {
          const data: any = response.toObject();
          if (data.commonout.code === 0) {
            const lastMessage = this.generateMessage()
            this.messagesArr.push(lastMessage)
            this.currentDialogue.lastmessage = lastMessage
            this.message = ''
            this.moveToEnd()
          } else if (data.commonout.code === 100211) {
            this.$message.error(this.$tc('dashbordDy.notWAUser'))
          } else if (data.commonout.code === 100212) {
            this.$message.error(this.$tc('dashbordDy.notLoginWA'))
          } else if (data.commonout.code === 100213) {
            this.$message.error(this.$tc('dashbordDy.alreadyLoginWA'))
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
      }
    );
  }
  public setMessageRead() {
    if (!this.currentDialogue?.islogin || !this.currentDialogue?.sendmobile || !this.currentDialogue?.recvmobile) {
      return
    }
    let request: any = new WAMsgReadReq();
    request.setCommonin(setCommon());
    // 发送者
    request.setWamobile(this.currentDialogue?.sendmobile)
    // 接受者
    request.setMobile(this.currentDialogue?.recvmobile)
    ticketClient.wAMsgRead(
      request,
      setMetaData(),
      (err: any, response: any) => {
        this.handleError(err)
        if (response) {
          const data: any = response.toObject();
          if (data.commonout.code === 100211) {
            this.$message.error(this.$tc('dashbordDy.notWAUser'))
          } else if (data.commonout.code === 100212) {
            this.$message.error(this.$tc('dashbordDy.notLoginWA'))
          } else if (data.commonout.code === 100213) {
            this.$message.error(this.$tc('dashbordDy.alreadyLoginWA'))
          } else if (data.commonout.code !== 0){
            this.$message.error(data.commonout.errmsg);
          }
        }
      }
    );
  }
  private handleError(err: any) {
    if (err) {
      if (err.code && err.code === 16) {
        this.$router.push("./login");
      } else {
        Vue.prototype.$message({
          message: err.errmsg ? err.errmsg : err.message,
          type: "error"
        });
      }
    }
  }
  private generateMessage() {
    return {
      messagecontent: this.message,
      messagetimestamp: new Date().getTime() / 1000,
      fromme: true,
      status: READ_STATUS.NOT_READ
    }
  }
  private moveToEnd() {
    setTimeout(() => {
      const messageBox: any = this.$refs.messageBox
      const message: any = this.$refs.message
      messageBox && (messageBox.scrollTop = message?.offsetHeight || 0)
    }, 300)
  }
}
